import styled from "styled-components";
import {
  variant,
  space,
  typography,
  TypographyProps,
  SpaceProps,
  color,
  ColorProps,
  flexbox,
  FlexboxProps,
  display,
  DisplayProps,
  ResponsiveValue,
  WidthProps,
  width,
  HeightProps,
  height,
  LayoutProps,
} from "styled-system";

export const TextVariants = {
  text1Regular: {
    fontFamily: "system-ui",
    fontWeight: "regular",
    fontSize: 2,
  },
  text1Bold: {
    fontFamily: "Open Sans",
    fontWeight: "bold",
    fontSize: 2,
  },
  text2Regular: {
    fontFamily: "system-ui",
    fontWeight: "regular",
    fontSize: 1,
  },
  text2Bold: {
    fontFamily: "Open Sans",
    fontWeight: "bold",
    fontSize: 1,
  },
  text3Regular: {
    fontSize: 0,
    fontWeight: "regular",
    fontFamily: "Open Sans",
  },
  text3Bold: {
    fontSize: 0,
    fontWeight: "bold",
    fontFamily: "Open Sans",
  },
  text4Regular: {
    fontSize: 0,
    fontWeight: "regular",
    fontFamily: "'system-ui'",
    fontStyle: "italic",
    opacity: 0.8,
  },
  text4Bold: {
    fontSize: 0,
    fontWeight: "bold",
    fontFamily: "emoji",
  },
  title1Bold: {
    fontSize: 3,
    fontWeight: "bold",
    fontFamily: "system-ui",
  },
  title2Bold: {
    fontSize: 2,
    fontWeight: "bold",
    fontFamily: "system-ui",
  },
  title3Bold: {
    fontSize: 1,
    fontWeight: "bold",
    fontFamily: "system-ui",
  },
  title2BisBold: {
    fontSize: "13px",
    fontWeight: "bold",
    fontFamily: "system-ui",
  },
  title5: {
    fontSize: 4,
    fontWeight: "bold",
    fontFamily: "system-ui",
  },
  textNormal: {
    fontFamily: "system-ui",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "normal",
    lineHeight: "20px",
  },
  title4: {
    fontSize: 3,
    fontWeight: "bold",
    fontFamily: "system-ui",
  },
  title6: {
    fontSize: 24,
    fontWeight: "bold",
    fontFamily: "system-ui",
  },
  title7: {
    fontSize: 28,
    fontWeight: "bold",
    fontFamily: "system-ui",
  },
  small: {
    fontSize: 0,
    fontWeight: "regular",
    fontFamily: "Open Sans",
  },
  cardElem: {
    fontWeight: "bold",
    fontFamily: "system-ui",
  },
};

type TextProps = {
  variant: ResponsiveValue<keyof typeof TextVariants>;
} & SpaceProps &
  ColorProps &
  DisplayProps &
  TypographyProps &
  FlexboxProps &
  WidthProps &
  HeightProps &
  LayoutProps;

const Text = styled("div")<TextProps>(
  space,
  typography,
  color,
  display,
  flexbox,
  width,
  height,
  {},
  variant({
    variants: TextVariants,
  })
);

Text.defaultProps = {
  color: "brand4",
};

export default Text;
